import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { SizeProps } from 'styled-system';
import { size } from 'styled-system';

import hcLogo from 'common/assets/icons/homeclub/logo.svg';
import { Flex } from 'common/components/Flex';
import { BodyRegularBR1 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import { isLocaleWithHomeClubQRCode } from '../utils/locale-with-qr-code';
import QRCodeSection from './QRCodeSection';

interface HomeClubLogoSectionProps {
  homeClubId: string;
  withTitle?: boolean;
}

const HC_LOGO_SIZE = 180;

const Container = styled(Flex)``;
const containerStyles: ComponentProps<typeof Container> = {
  pt: 'sp_16',
  pb: ['sp_16', null, null, 'sp_20'],
  px: 'sp_16',
  flexDirection: 'column',
  alignItems: 'center',
};

const StyledIcon = styled.img<SizeProps>`
  ${size};
`;

const HomeClubLogoSection = ({ homeClubId, withTitle = false }: HomeClubLogoSectionProps) => {
  const { t, locale } = useLocalization();

  if (isLocaleWithHomeClubQRCode(locale)) {
    return <QRCodeSection homeClubId={homeClubId} withTitle={withTitle} />;
  }

  return (
    <Container {...containerStyles}>
      <StyledIcon alt="" src={hcLogo} size={HC_LOGO_SIZE} />
      <BodyRegularBR1 mt="sp_12">{`${t('h24_hc_id')} ${homeClubId}`}</BodyRegularBR1>
    </Container>
  );
};

export default HomeClubLogoSection;
